import _ from 'underscore';
import WorkRampAdminAppOptions from '~/navigation/admin-app-options';
import WorkRampAnalyticsAppOptions from '~/navigation/analytics-app-options';
import AppNavigationOption from '~/navigation/app-navigation-option';
import { CustomerLearningCloudAppOptions } from '~/navigation/CustomerLearningCloudAppOptions';
import isFeatureEnabled from '~/components/common/is-feature-enabled';

class AppNavigation {
  constructor(code, currentUser, academyId = null, customerLearningCloudHubId = null) {
    if (customerLearningCloudHubId) {
      this.optionsHash = CustomerLearningCloudAppOptions(academyId, customerLearningCloudHubId);
    } else {
      this.optionsHash =
        {
          0: WorkRampAdminAppOptions,
          4: WorkRampAnalyticsAppOptions,
        }[code] || {};
    }
    this.currentUser = currentUser;
    this.urlParts = window.location.pathname.split('/').filter((p) => !!p);
  }

  menuOptionsHashById() {
    const hashById = {};
    Object.entries(this.optionsHash).forEach(([__, data]) => (hashById[data.id] = data));
    return hashById;
  }

  getMenuOptions() {
    return this._getMenuOptionsHelper(this.optionsHash);
  }

  getMenuFromKey(menuKey, _user) {
    if (!menuKey) return null;

    const { id } = menuKey;
    return this.menuOptionsHashById()[id];
  }

  getSubmenuOptions(menuOption, user, subMenuOptions = null) {
    const subMenusToFilter = subMenuOptions || menuOption.submenus || {};
    return this._getMenuOptionsHelper(subMenusToFilter);
  }

  getSubmenuFromKey(menuKey, user, path) {
    const menu = this.getMenuFromKey(menuKey, user);

    if (!menu) return {};

    let submenus = _.values(menu.submenus).filter(
      (submenu) => submenu.shouldShow === undefined || submenu.shouldShow(),
    );
    const submenuId = menuKey.submenu ? menuKey.submenu.id : undefined;

    if (menu.options) {
      submenus = menu.options;
    }

    // Find matching submenu by comparing the current path to the submenu's route.
    // If no route matches it falls back to the submenu's id.
    const matchingRoute = submenus.find(
      (submenu) => submenu.route !== undefined && path !== undefined && path.match(submenu.route),
    );

    if (matchingRoute) {
      return matchingRoute;
    }

    return _.find(submenus, (submenu) => submenu.id === submenuId);
  }

  _getMenuOptionsHelper(optionsHash) {
    return Object.entries(optionsHash)
      .map(([key, value]) => new AppNavigationOption(key, value, this.currentUser))
      .filter((navOption) => navOption.shouldShow())
      .sort((navOptionA, navOptionB) => navOptionA.sortOrder() - navOptionB.sortOrder())
      .map((navOption) => navOption.values());
  }

  isAcademyDashboard(menu) {
    return menu.hasOwnProperty('id') && menu.id === this.optionsHash.ACADEMIES?.id && !menu.hasOwnProperty('academyId');
  }

  isSingleAcademyPage(menu) {
    return menu.hasOwnProperty('academyId') && this.urlParts[1] === 'academies' && !!this.urlParts[2];
  }
}

export default AppNavigation;
